export const LibraryEndAudioData = {
    voiceover: {
        id: 'library-voiceover-end',
    },
    gesture: {
        samples: [
            { name: 'gesture-end1' },
            { name: 'gesture-end2' },
        ],
        volume: -6,
    },
    scenes: [
        // 0: Library
        {
            name: "Library End",
            background: {
                samplePool: ['library-background-end'],
                volume: -9,
                fadeInDuration: 2,
                fadeOutDuration: 2,
                loopStart: 0,
                loopEnd: 20458,
            },
        }
    ]
};
